import { useQuery } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisEnergyBalanceReadDTO } from '../generated/api-client';

export const useDiagnosisEnergyBalanceByDiagnosisId = (diagnosisId?: string) => {
  return useQuery<DiagnosisEnergyBalanceReadDTO[]>(
    ['diagnosis-energy-balance', diagnosisId],
    () => {
      if (!diagnosisId) {
        return Promise.resolve([]);
      }
      return apiClient.get_by_diagnosis_diagnosis_energy_balance_by_diagnosis__diagnosis_id__get(
        diagnosisId
      );
    },
    {
      enabled: !!diagnosisId,
    }
  );
};

